import { PaymentType, Feature } from '@afterpay/types'
import { ConsumerFeeItem } from '@afterpaytouch/portal-api'

export const getFeatureFromPaymentType = ({ paymentType, isAFF = false }: { paymentType: PaymentType; isAFF: boolean }): Feature => {
  if (isAFF) {
    return Feature.AFF
  }

  switch (paymentType) {
    case PaymentType.PBI:
      return Feature.PBI
    case PaymentType.PCL:
      return Feature.PCL
    default:
      return Feature.PBI
  }
}

export const isAfterpayFinanceFeeEligible = (consumerFees?: ConsumerFeeItem[]): boolean => {
  const supFinanceFee = consumerFees?.find((fee) => fee.type === 'CONSUMER_FINANCE_FEE' && typeof fee.variableAmount !== 'undefined')
  return typeof supFinanceFee?.variableAmount !== 'undefined'
}
